import React from 'react';
import { Box, Typography } from '@mui/material';
import ActionButton from '../components/ActionButton';
import BrandLogo from '../components/BrandLogo';
import NotificationBell from '../components/NotificationBell';
import { useAuth } from '../hooks/useAuth';

const Dashboard: React.FC = () => {
  const { user, logout, isLoggingOut } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
        <NotificationBell />
      </Box>
      <BrandLogo variant="horizontal" height={64} width="auto" />
      <Typography variant="h5" component="h1">
        Signed in as {user?.name}
      </Typography>
      <Typography color="text.secondary">
        {user?.center
          ? `Center: ${user.center.name}`
          : 'No center assigned'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Role: {user?.role}
      </Typography>
      <ActionButton
        variant="outline"
        onClick={() => void logout()}
        loading={isLoggingOut}
        sx={{ mt: 2 }}
      >
        Sign out
      </ActionButton>
    </Box>
  );
};

export default Dashboard;
